import { useEffect, useState } from "react";

const PremiumPopop = () => {
    const [left, setLeft] = useState("23px");
    const adjustLeftPosition = () => {
        let leftPosition = (window.innerWidth / 2) - 375;
        
        if(document.querySelector('.premium-popup')) {
            let elWidth = document.querySelector('.premium-popup')?.getBoundingClientRect().width;
            leftPosition = ((window.innerWidth - elWidth) / 2) + 'px';
        }
        return leftPosition;
    }

    useEffect(() => {
        setLeft(adjustLeftPosition());
    }, [])

    return (
        <div className='gradient-b-r-15 premium-popup' style={left && window.innerWidth < 901 ? {"left": left} : null}>
        <div>
            <div className="flex-box" style={{"width" : "100%", "alignItems": "baseline", "marginBottom": "15px"}}>
                <h3 className='inter-medium-16' style={{"textAlign": "left", "flex": "1"}}>
                    <img src="/img/premium-28-white.png" className="h3-icon" alt='premium icon' style={{"marginRight": "20px", "marginTop": "-5px"}} />
                    Unlock Premium Plans
                </h3>
                <a href='/premiumplans' className='upgr-btn inter-bold-16 right'>Upgrade now</a>
            </div>
            <p className='inter-medium-16 gray-txt'>
                Unlock full analytics to understand what’s really happening — track top signals, 
                recent performance, and real impact over time. See which tokens gain traction, 
                which influencers consistently move the market, and how trends unfold.
                Hold <span className='blue-txt'>$SGT</span> to activate.
            </p>
        </div>
    </div>
    )
}

export default PremiumPopop;